import { render, staticRenderFns } from "./9.vue?vue&type=template&id=65ae4d5a&"
import script from "./9.vue?vue&type=script&lang=js&"
export * from "./9.vue?vue&type=script&lang=js&"
import style0 from "./9.vue?vue&type=style&index=0&id=65ae4d5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports